import { useMutation } from "@tanstack/react-query";
import { createAxiosWithAuth } from "./middleware";

export const useRemoveMemberFromChat = () => {
  const axios = createAxiosWithAuth();

  return useMutation({
    mutationKey: ["remove_member"],
    mutationFn: async (query) => {
      return await axios.post("/chat/removemember", query);
    },
  });
};